export class BaseValidationModel {

	public isValid(): boolean {
		return Object.keys(this).length > 0
	}
}
